'use strict';

angular.module('documentsManagement')
  .controller('DocumentEditCtrl', [
    '$scope', 'documentEditingBaseModel', '$$masterId', '$$documentId', '$$documentsApiUrl', '$modalInstance',
    function (scope, viewModel, $$masterId, $$documentId, $$documentsApiUrl, $modalInstance) {
      scope.vm = new viewModel($$masterId, $$documentId, $$documentsApiUrl, $modalInstance);
    }
  ]);